export enum  DateRangeEnum{
    Custom = "Custom",
    LastWeek = "LastWeek",
    LastMonth = "LastMonth",
    LastYear = "LastYear"
}